export default __webpack_public_path__ + "static/media/phone.fe4dea6d.svg";